import Animation from 'features/Animation/Home'

export default () =>
  <div className="my-2 article-width">
    <Animation />
  </div>
